import { css } from '@emotion/css';
import React from 'react';
import bgBalloonTalk from '../../assets/images/bg-balloon-talk.svg';

export const BalloonTalk: React.FC<{ text: string }> = ({ text }) => {
  const from = 'Sara';
  return (
    <div
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
        color: #4d3906;
        background-image: url(${bgBalloonTalk});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 44px;
        position: relative;
        padding: 0 18px 6px;

        &::before {
          content: '${from}';
          display: flex;
          align-items: center;
          position: absolute;
          top: -12px;
          left: -8px;
          height: 20px;
          border-radius: 12px;
          background: #F95FA5;
          color: white;
          font-size: 12px;
          padding: 0 6px;
        }
      `}
      aria-hidden={true}
    >
      {text}
    </div>
  );
};
